module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.article) ? _c('article-detail-component', [(!_vm.$store.state.isEnhanced) ? _c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.article.authors
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('sidebar-article-section', {
    attrs: {
      "slot": "bar",
      "article": _vm.article
    },
    slot: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "keywords",
    attrs: {
      "slot": "keywords"
    },
    slot: "keywords"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n      Keywords:\n    ")]), _vm._v(" "), _c('div', {}, _vm._l((_vm.article.keywords), function(keyword) {
    return _c('div', {
      staticClass: "link"
    }, [_vm._v(_vm._s(keyword))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "current-issue",
    attrs: {
      "slot": "current_article"
    },
    slot: "current_article"
  }, [_c('em', [_vm._v("Current Article:")]), _vm._v(" "), _c('condensed-issue', {
    staticClass: "mt-2",
    attrs: {
      "issue": _vm.article
    }
  })], 1), _vm._v(" "), _c('div', _vm._l((_vm.issues), function(issue, index) {
    return (index < 5) ? _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue
      }
    }) : _vm._e()
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0912f6a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/RelatedArticlesPage.vue
// module id = 1383
// module chunks = 1